import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import React, { useState, useMemo, Component} from "react";
import ReactDOM from 'react-dom';
import { useEffect } from "react";
import { Form } from "react-bootstrap";
import nanoid from "nanoid"; 
import moment from 'moment';
import { useStore } from '../../../providers/AppProvider';
import { MapLayer } from "../../../deckgl/MapLayer";
import { useL2RasterDataSources} from "../../../hooks/useL2RasterDataSources";
import { DataSourceLayerMeta, DataSourceRasterLayer, LayerVisibility } from "../../../types/types";
import { getTileUrlTemplate } from "../../../../fields/utils/dataSourceUtils";
import Gradient from "../../../../../components/Gradient";
import Slider, { Range } from 'rc-slider';
import Tooltip from 'rc-tooltip';
import bbox from "@turf/bbox";
import { SETTING_SEASON_YEAR } from '../../../utils/settings';
import { HIGH_RES_TWI, HIGH_RES_SLOPE, HIGH_RES_PROFILECURVATURE, HIGH_RES_PLANIMETRICCURVATURE, HIGH_RES_ELEVATION, HIGH_RES_ASPECT } from "../../../constants";
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingSpinnerSmall } from '../../../../../components/LoadingSpinnerSmall';
import { dcRound } from "../../../utils/misc";

interface IProps {
    addMapLayer: (layers: MapLayer) => void,
    refresh: () => void,
    fieldId: number | null,
    field: any,
    rasterDataSources: any,
    setRasterDataSources: Function,
    bbCardDataSources: any,
    setBbCardDataSources: Function,
    setBbCardDataCounter: Function,
    setPlantsCounter: Function,
    setLoadedTiles: Function,
    loadedTiles: boolean,
    setTimelineStatus?: Function | null,
    timelineStatus?: string | null,
    dateSelectorParameters: any, 
    setDateSelectorParameters: Function,
    activeAnimation: string,
    setActiveAnimationFromParent: Function,
    animationRasterDataSources: any,
    setAnimationRasterDataSources: Function,
    UASImageryAnimationRasterDataSources: any,
    setUASImageryAnimationRasterDataSources: Function,
    staticRasterDataSources: any,
    setStaticRasterDataSources: Function,
    setDatesAvailable: Function,
    datesAvailable: Array<string>,
    setVisible: Function,
    visible: boolean,
    filteredDatesAvailable: Array<string>,
    setFilteredDatesAvailable:Function,
    setDwAndRasterTimelineDate:Function,
    setDwAndRasterTimelineDateComplete:Function,
    dwAndRasterTimelineDate:string | null,
    visibleDW: boolean,
    setVisibleDW: Function,
    plantDateIndexSelected?: Array<number> | null,
    setPlantDateIndexSelected?: Function | null,
 };

const L2ImagerySourceLayer = ({ addMapLayer, refresh, fieldId, field, rasterDataSources, setRasterDataSources,bbCardDataSources, setBbCardDataSources, setBbCardDataCounter, setPlantsCounter, setLoadedTiles, loadedTiles, activeAnimation, setActiveAnimationFromParent, animationRasterDataSources, UASImageryAnimationRasterDataSources, setUASImageryAnimationRasterDataSources, setAnimationRasterDataSources, staticRasterDataSources, setStaticRasterDataSources,setDatesAvailable, datesAvailable, visible, setVisible, dateSelectorParameters, setDateSelectorParameters,setTimelineStatus=null, timelineStatus=null, filteredDatesAvailable, setFilteredDatesAvailable, setDwAndRasterTimelineDate, setDwAndRasterTimelineDateComplete, dwAndRasterTimelineDate, visibleDW, setVisibleDW, plantDateIndexSelected=null, setPlantDateIndexSelected=null}: IProps) => {
    //console.log("082223 fieldId", fieldId)
    const { createSliderWithTooltip } = Slider;
    const Slider2 = createSliderWithTooltip(Slider.Range);
    const { Handle } = Slider;
    const handle = (props:any) => {
        //console.log("082223 props", props);
        const { value, dragging, index, ...restProps } = props;
        //console.log("082223 value", value);
        return (
          <Tooltip
            prefixCls="rc-slider-tooltip"
            overlay={value}
            visible={dragging}
            placement="top"
            key={index}
          >
            <Handle value={value} {...restProps} />
          </Tooltip>
        );
    };

    const [selectedId, setSelectedId] = useState<any | null>(null);
    const [selectedCounter, setSelectedCounter] = useState<number>(0);
    const [selected, setSelected] = useState<DataSourceRasterLayer | null>(null);
    const [highResNormalColor, setHighResNormalColor] = useState<DataSourceRasterLayer | null>(null);

    const [gradientParameters, setGradientParameters] = useState<any>([[0,"rgb(255,255,255)"],[1,"rgb(0,0,0)"]]);
    const [colorRampParameters, setColorRampParameters] = useState<any>([0,30]);
    let todayDate = new Date();
    const [dateSelected, setDateSelected] = useState<string>( new Date(todayDate.getTime() - (todayDate.getTimezoneOffset() * 60000)).toISOString().split('T')[0]);
    const [dateIndexSelected, setDateIndexSelected] = useState<Array<number>>([0,0,0]);

    const { orgId } = useStore();

    // Vegetation Index
    // Chlorophyll Index
    // Pigmentation Index
    // Natural Color
    // Color IR
    // Thermal IR
    const EXCLUDE_RASTER_DATA_SOURCES: any = [
        `${orgId}${HIGH_RES_TWI}`,
        `${orgId}${HIGH_RES_SLOPE}`,
        `${orgId}${HIGH_RES_PROFILECURVATURE}`,
        `${orgId}${HIGH_RES_PLANIMETRICCURVATURE}`,
        `${orgId}${HIGH_RES_ELEVATION}`,
        `${orgId}${HIGH_RES_ASPECT}`,
    ];

    const { dataSources, loading} = useL2RasterDataSources(EXCLUDE_RASTER_DATA_SOURCES);

    const { settings, updateSettings } = useStore();
    const [year, setYear] = useState(settings[SETTING_SEASON_YEAR]);

    useEffect(() => {
        if (timelineStatus){
         handleAnimationFrame(dateSelectorParameters.sequence[timelineStatus][0]);
        }
    }, [timelineStatus]);

    useEffect(() => {
        if (setPlantDateIndexSelected){
           setPlantDateIndexSelected(dateIndexSelected);
        }
    }, [dateIndexSelected]);

    useEffect(() => {
        setYear(settings[SETTING_SEASON_YEAR])
    }, [settings]);

    useEffect(() => {
        console.log("082223 year", year);
        if ( selected ){
            setDateIndexSelected([0,0,0])
            getAvailableDates(selected.id)
            //"185647c4-c577-11ec-93f4-024a2a01d41b-vvi",  // Example asset ID
            //[-120.195556, 36.796791, -120.19094, 36.803012],  // Bounding Box
            //"2025"  // Year filter
            //getAssetClippedToBounds(selected.id, field.geom);
            /*
            const bounds = {
                west: -124.409591,
                south: 32.534156,
                east: -114.131211,
                north: 42.009485
            };
            getAssetClippedToBounds(selected.id, bounds );
            getAssetTileImage(selected.id, bounds );
            */
        }

    }, [year, field]);

    useEffect(() => {
        if (dateIndexSelected && dateSelectorParameters && dateSelectorParameters?.min_date){
            console.log("062023 datesAvailable", datesAvailable)
            console.log("062023 dateSelectorParameters", dateSelectorParameters)
            console.log("062023 dwAndRasterTimelineDate", dwAndRasterTimelineDate)
            console.log("062023 dateSelected", dateSelected)
            console.log("062023 dateIndexSelected", dateIndexSelected)
            console.log("062023 dateSelectorParameters.marks[dateIndexSelected[1]]", dateSelectorParameters.marks[dateIndexSelected[1]])
            let _dateIndexSelected = dateIndexSelected;
            // If the index selected is not a date that is available, then set the index to the latest available date
            if (dateSelectorParameters.marks[dateIndexSelected[1]]){

            }else{
                _dateIndexSelected = [dateIndexSelected[0],dateIndexSelected[2],dateIndexSelected[2]]
            }
            handleAfterSliderChange(_dateIndexSelected, "A");
        }
    }, [dateSelectorParameters]);

    useEffect(() => {
        console.log("loadedTiles", loadedTiles)
    }, [loadedTiles]);

    useEffect(() => {
        if( dataSources.length) {
            console.log("dataSources",dataSources);
            const preferredDefault = dataSources.filter((ds: DataSourceRasterLayer) => {
                return ds.name === "High Res. Vegetation Index";
            });
            if (preferredDefault.length){
                setSelected(preferredDefault[0]);
            }else{
                setSelected(dataSources[0]);
            }
            const normalColorSource = dataSources.filter((ds: DataSourceRasterLayer) => {
                return ds.name === "High Res. Normal Color";
            });
            if (normalColorSource.length){
                setHighResNormalColor(normalColorSource[0])
            }
            if (preferredDefault.length){
                getAvailableDates(preferredDefault[0].id);
                createDateSelectorParameters(preferredDefault[0]);
            }else{
                getAvailableDates(dataSources[0].id);
                createDateSelectorParameters(dataSources[0]);
            }
        }
    }, [loading, dataSources]);

    useEffect(() => {
        if (selected?.source?.color_ramp){
            console.log("030123 JSON.parse(selected.source.color_ramp)",JSON.parse(selected.source.color_ramp))
            setGradientParameters(JSON.parse(selected.source.color_ramp))
            setColorRampParameters([selected.source.global_min,selected.source.global_max])
        }
    }, [selected]);

    useEffect(() => {
        if(dataSources.length > 0){
            console.log("B111423 dataSources", dataSources);
            console.log("060523 selected", selected);
            console.log("060523 selectedId", selectedId);
            const _selectedId = selectedId ? selectedId.id : (selected ? selected.id : dataSources[0].id);
            console.log("060523 _selectedId", _selectedId);
            const dsLayerFiltered = dataSources.filter((ds: DataSourceRasterLayer) => {
                return ds.id === _selectedId;
            });
            const bbLayerFiltered = dataSources.filter((bb: DataSourceRasterLayer) => {
                //console.log("B111423 bb", bb);
                return bb.name === "High Res. Vegetation Index";
            });
            console.log("060523 dsLayerFiltered", dsLayerFiltered);
            console.log("B111423 bbLayerFiltered", bbLayerFiltered);
            let dsLayer = dsLayerFiltered[0];
            let bbLayer = bbLayerFiltered[0];
            if (dsLayerFiltered.length > 1){
                const dsLayerFind = dsLayerFiltered.find((s:any) => {
                    return s.name === selectedId.disambiguate;
                });
                if (dsLayerFind){ dsLayer = dsLayerFind };
            }
            if (bbLayerFiltered.length > 1){
                const bbLayerFind = bbLayerFiltered.find((s:any) => {
                    return s.name === selectedId.disambiguate;
                });
                if (bbLayerFind){ bbLayer = bbLayerFind };
            }

            if(dsLayer) {
                if (datesAvailable.length > 0){
                    setStaticRasterDataSources([(dsLayer)])                    
                }else{
                    setStaticRasterDataSources([])
                    console.log("AAA052523 dsLayer", dsLayer);
                }
                console.log("060523 dsLayer", dsLayer);
                setSelected(dsLayer);
                createDateSelectorParameters(dsLayer);
                setSelectedCounter((prevState:number) => {
                    return prevState + 1;
                });
            }

            if(bbLayer) {
                if (datesAvailable.length > 0){
                    setBbCardDataSources([(bbLayer)]) 
                    setBbCardDataCounter((prevState:number) => { return prevState + 1 });                   
                }else{
                    setBbCardDataSources([])
                    setBbCardDataCounter((prevState:number) => { return prevState + 1 });
                    console.log("C111423 bbLayer", bbLayer);
                }
                console.log("C111423 bbLayer", bbLayer);
                //setSelected(dsLayer);
                //createDateSelectorParameters(dsLayer);
                //setSelectedCounter((prevState:number) => {
                //    return prevState + 1;
                //});
            }
        }
    }, [datesAvailable]);

    const onDateChange = (newDate:string, updateSequence:string) => {
        console.log("B021424 A newDate", newDate);
        setDwAndRasterTimelineDate(newDate);
        if (updateSequence === "final"){
            setDwAndRasterTimelineDateComplete(true);
        }

        let dsLayer = selected;
        if(dsLayer) {
            const source = dsLayer.source;
            dsLayer.tiles = getTileUrlTemplate(
                source,
                source.stac_address!, 
                source.collection_id!,
                'footprint_id',
                source.min_date,
                newDate,//dateSelected,
                source.date_display_resolution!,
                "template-singledate-p1",
                null,
            )
            dsLayer.uuid = nanoid(8);
            setStaticRasterDataSources([dsLayer]);
            setSelected(dsLayer);
        }
        console.log("E111423 bbCardDataSources", bbCardDataSources);
        /*if(bbCardDataSources.length > 0) {
            const source = bbCardDataSources[0].source;
            const bbLayer = bbCardDataSources[0];
            console.log("E111423 source", source);
            bbLayer.tiles = getTileUrlTemplate(
                source,
                source.stac_address!, 
                source.collection_id!,
                'footprint_id',
                source.min_date,
                newDate,//dateSelected,
                source.date_display_resolution!,
                "template-singledate-p1",
                null,
            )
            console.log("E111423 bbLayer.tiles", bbLayer.tiles);
            bbLayer.uuid = nanoid(8);
            setBbCardDataSources([bbLayer]);
            setBbCardDataCounter((prevState:number) => { return prevState + 1 });
        }*/
        let rasterDataSources2:DataSourceRasterLayer[] = [];
        if (rasterDataSources.length > 0){
                rasterDataSources.forEach((d: DataSourceRasterLayer, index:number) => {
                    console.log("080823 onDateChange > d", d);
                    console.log("082223 onDateChange year", year);
                    if ((d.name === "UAS Imagery")||(d.dataSourceMeta?.date)){
                        const sourceUAS = d.source;
                        d.tiles = getTileUrlTemplate(
                            sourceUAS,
                            sourceUAS.stac_address!, 
                            sourceUAS.collection_id!,
                            'footprint_id',
                            d.dataSourceMeta?.date ? `${year}-01-01` : sourceUAS.min_date,
                            d.dataSourceMeta?.date ? `${year}-12-31` : newDate, //dateSelected,
                            sourceUAS.date_display_resolution!,
                            d.dataSourceMeta?.date ? "template" : "template-singledate-p1",
                            null,
                        )
                        if (d.name === "UAS Imagery"){
                            d.uuid = nanoid(8);
                        }
                        if (d.dataSourceMeta?.date){
                            if (d.dataSourceMeta?.date != year){
                                d.uuid = nanoid(8);
                            }
                        }
                    }
                    rasterDataSources2.push(d);
                });
            setRasterDataSources(rasterDataSources2);
        }
        let bbCardDataSources2:DataSourceRasterLayer[] = [];
        if (bbCardDataSources.length > 0){
                bbCardDataSources.forEach((d: DataSourceRasterLayer, index:number) => {
                    console.log("D111423 onDateChange > d", d);
                    console.log("D111423 onDateChange year", year);
                    if ((d.name === "UAS Imagery")||(d.dataSourceMeta?.date)){
                        const sourceUAS = d.source;
                        d.tiles = getTileUrlTemplate(
                            sourceUAS,
                            sourceUAS.stac_address!, 
                            sourceUAS.collection_id!,
                            'footprint_id',
                            d.dataSourceMeta?.date ? `${year}-01-01` : sourceUAS.min_date,
                            d.dataSourceMeta?.date ? `${year}-12-31` : newDate, //dateSelected,
                            sourceUAS.date_display_resolution!,
                            d.dataSourceMeta?.date ? "template" : "template-singledate-p1",
                            null,
                        )
                        if (d.name === "UAS Imagery"){
                            d.uuid = nanoid(8);
                        }
                        if (d.dataSourceMeta?.date){
                            if (d.dataSourceMeta?.date != year){
                                d.uuid = nanoid(8);
                            }
                        }
                    }
                    bbCardDataSources2.push(d);
                });
            setBbCardDataSources(bbCardDataSources2);
            setBbCardDataCounter((prevState:number) => { return prevState + 1 });
        }
    }

    const handleAnimationFrame = (n: any) => {
        if (setDateIndexSelected && dateIndexSelected){
            setDateIndexSelected([dateIndexSelected[0],n,dateIndexSelected[2]]);
        }
    }
    
    const createDateSelectorParameters = (_dsLayer:any) => {
        console.log("A082223 createDateSelectorParameters > _dsLayer", _dsLayer);
        console.log("A082223 createDateSelectorParameters > datesAvailable", datesAvailable);
        console.log("A082223 year", year);
        const _max_date = `${year}-12-31`;
        const _min_date = `${year}-01-01`;
        console.log("A082223 _min_date", _min_date);
        console.log("A082223 _max_date", _max_date);
        const _datesPossible = enumerateDaysBetweenDates(_min_date, _max_date );
        console.log("A082223 _datesPossible", _datesPossible);
        console.log("A082223 datesAvailable", datesAvailable);
        let _marks = {};
        let _sequence:any = {};
        let _lastIndex = 0;
        let _firstIndex = -99;
        _datesPossible.forEach(function(date:string, index:number) {
            if (datesAvailable.includes(date)){
                let mmdd = `${date.split("-")[1]}-${date.split("-")[2]}`
                _marks[index] = <div className="rotateTick90">{mmdd}</div>;
                _sequence[date] = [index,mmdd]
                _lastIndex = index;
                if (_firstIndex == -99){
                    _firstIndex = index;
                }
            }
        });
        let uniqueDatesAvailable = datesAvailable.filter((element, index) => {
            return datesAvailable.indexOf(element) === index;
        });
        if (_firstIndex !== -99){
            setDateIndexSelected([_firstIndex, _lastIndex, _lastIndex]);
            
            const _params = {
                totalDays: _datesPossible.length,
                max_date: _max_date, //_dsLayer.source.max_date,
                min_date: _min_date, //_dsLayer.source.min_date,
                marks:_marks,
                sequence:_sequence,
                dates: uniqueDatesAvailable,
            }
            console.log("A082223 createDateSelectorParameters > _params", _params);
            setDateSelectorParameters( _params )
        }
        let _middleIndex = 0; 
        let p = dateIndexSelected[1];
        let n = dateIndexSelected[1];
        let _vettedDateSelection = _lastIndex;
        while ((p < _lastIndex || n >= 0) && (p !== _lastIndex || n !== _firstIndex ) && (_vettedDateSelection === _lastIndex)) {
            if (_marks[p]){
                _vettedDateSelection = p;
            }
            if ((n >= 0) && _marks[n]){
                _vettedDateSelection = n;
            }
            p++;
            n--;
        }
        //let _vettedDateSelection = _marks[dateIndexSelected[1]] ? dateIndexSelected[1] : 0;
        if (dateIndexSelected[1] === 0){
            _middleIndex = _lastIndex; 
        }else{
            if (dateIndexSelected[1] === dateIndexSelected[2]){
                _middleIndex = dateIndexSelected[1];
            }else{
                _middleIndex = _vettedDateSelection; /*(dateIndexSelected[1] > _firstIndex) 
                                        ? (dateIndexSelected[1] > _lastIndex) 
                                        ? _lastIndex
                                        : dateIndexSelected[1]
                                        : _firstIndex*/
            }
        }
        setDateIndexSelected([_firstIndex, _middleIndex, _lastIndex]);
        const _params = {
            totalDays: _datesPossible.length,
            max_date: _max_date, //_dsLayer.source.max_date,
            min_date: _min_date, //_dsLayer.source.min_date,
            marks:_marks,
            sequence:_sequence,
            dates: uniqueDatesAvailable,
        }
        if (datesAvailable.length > 0){
            setDateSelectorParameters( _params )
        }else{
            console.log("A082223 _params", _params);
            console.log("062023 _dsLayer", _dsLayer);
            console.log("B021424 -- B");
            onDateChange(_params.max_date, "initial");
            setDateSelectorParameters( null )
        }
    }

    const enumerateDaysBetweenDates = function(_startDate:string, _endDate:string) {
        var dates = [];
        let startDate = moment(new Date(_startDate));
        let endDate = moment(new Date(_endDate));
        startDate = startDate.add(1, 'days');
        while(startDate.format('YYYY-MM-DD') !== endDate.format('YYYY-MM-DD')) {
          dates.push(startDate.format('YYYY-MM-DD'));
          startDate = startDate.add(1, 'days');
        }
        dates.push(startDate.format('YYYY-MM-DD'));
        startDate = startDate.add(1, 'days');
        dates.push(startDate.format('YYYY-MM-DD'));
        console.log("062023 dates",dates)
        return dates;
      };

    const onSourceChange = (e: any) => {
        if(!dataSources) return;
        setSelectedId(JSON.parse(e.target.value))
        console.log("060523 e", e)
        console.log("060523 JSON.parse(e.target.value)", JSON.parse(e.target.value))
        const dsLayerFiltered = dataSources.filter((ds: DataSourceRasterLayer) => {
            return ds.id === JSON.parse(e.target.value).id;
        });
        let dsLayer = dsLayerFiltered[0];
        if (dsLayerFiltered.length > 1){
            const dsLayerFind = dsLayerFiltered.find((s:any) => {
                return s.name === selectedId.disambiguate;
            });
            if (dsLayerFind){ dsLayer = dsLayerFind };
        }

        if(dsLayer) {
            if (datesAvailable.length > 0){
                setStaticRasterDataSources([(dsLayer)])                    
            }else{
                setStaticRasterDataSources([])
                console.log("AAA052523 dsLayer", dsLayer);
            }
            console.log("060523 dsLayer", dsLayer);
            setSelected(dsLayer);
            //createDateSelectorParameters(dsLayer);
            //setSelectedCounter((prevState:number) => {
            //    return prevState + 1;
            //});
        }
        getAvailableDates(JSON.parse(e.target.value).id);
    }

    const getAvailableDates = (_selectedId:string | null) => {
        console.log("060523 getAvailableDates > _selectedId", _selectedId);
        var xhr = new XMLHttpRequest()
        xhr.addEventListener('load', () => {
            console.log("060523 xhr", xhr);
            if (xhr.responseText.includes("index_not_found_exception")){
                console.log("060523 index_not_found_exception");
                setDwAndRasterTimelineDate("no dates available");
                setDatesAvailable([]);
            }else{
                console.log("xhr", xhr);
                const _response = JSON.parse(xhr.responseText);
                let newDatesAvailable:Array<string> = [];
                _response.features.forEach(function(f:any, index:number) {
                    console.log("062624", f.properties.datetime.split('T')[0], f.properties.updated.split('T')[0], f.properties.created.split('T')[0])
                    newDatesAvailable.push(f.properties.datetime.split('T')[0])
                });
                let uniqueDatesAvailable = newDatesAvailable.filter((element, index) => {
                    return newDatesAvailable.indexOf(element) === index;
                });
                console.log("062023 uniqueDatesAvailable.reverse()",uniqueDatesAvailable.reverse()) 
                if (uniqueDatesAvailable.length === 0){
                    setDwAndRasterTimelineDate("no dates available");
                } 
                console.log("062023 dwAndRasterTimelineDate",dwAndRasterTimelineDate) 
                setDatesAvailable(uniqueDatesAvailable.reverse());

            }
        })
        // https://stac-server-test.syncarto.com/search?bbox=[-120.195556,36.796791,-120.19094,36.803012]&datetime=2024-01-01/2024-12-31&limit=200&collections=63e2ddf0-b67d-11ec-ba45-024a2a01d41b-vvi
        //let _url = "https://stac-server-test.syncarto.com/collections/185647c4-c577-11ec-93f4-024a2a01d41b-vvi/items"
        //let _url = "https://stac-server-test.syncarto.com/search?bbox=[-121.893310546875,38.66406704456943,-121.8878173828125,38.668356101515066]&datetime=2020-05-29/2023-01-01&collections=185647c4-c577-11ec-93f4-024a2a01d41b-pgi"
        if (_selectedId){
            //let _url = `https://stac-server-test.syncarto.com/collections/${_selectedId}/items`;
            const dsLayerFiltered = dataSources.filter((ds: DataSourceRasterLayer) => {
                //console.log("ds", ds);
                //console.log("_selectedId", _selectedId);
                return ds.id === _selectedId;
            });
            //console.log("dsLayerFiltered[0]", dsLayerFiltered[0])
            console.log("082223 year", year);
            let _url = `${dsLayerFiltered[0].source.stac_address}?bbox=[${ bbox(field.geom).toString()}]&datetime=${year}-01-01/${year}-12-31&limit=200&collections=${_selectedId}`;
            //console.log(_url);
            xhr.open('GET', _url)
            xhr.send()
        }
    }

    const getAssetTileImage = async (_selectedId: string, bounds: any) => {
        console.log("B030215 Fetching clipped asset tile for", _selectedId);
    
        if (!_selectedId) {
            console.error("B030215  No selected asset ID provided.");
            return;
        }
    
        // Filter data sources to find the correct STAC address
        const dsLayerFiltered = dataSources.filter((ds: any) => ds.id === _selectedId);
        if (dsLayerFiltered.length === 0) {
            console.error("B030215  No data source found for", _selectedId);
            return;
        }
    
        // Construct STAC query URL
        const stacUrl = `${dsLayerFiltered[0].source.stac_address}?bbox=[${bounds.west},${bounds.south},${bounds.east},${bounds.north}]&collections=${_selectedId}&limit=1`;
        console.log("B030215  STAC Query URL:", stacUrl);
    
        try {
            const stacResponse = await fetch(stacUrl);
            if (!stacResponse.ok) throw new Error("STAC request failed.");
            const stacData = await stacResponse.json();
    
            if (!stacData.features || stacData.features.length === 0) {
                console.log("B030215  No assets returned from STAC.");
                return;
            }
    
            // Extract asset URL
            const firstFeature = stacData.features[0];
            let assetUrl = firstFeature.assets.data?.href || firstFeature.assets.image?.href;
    
            if (!assetUrl) {
                console.error("B030215  No valid asset URL found.");
                return;
            }
    
            console.log("B030215  Asset URL:", assetUrl);
    
            // Compute Tile Coordinates
            const { x, y, z } = getTileCoordinates(bounds, 14);
            console.log(`B030215  Computed Tile Coordinates: z=${z}, x=${x}, y=${y}`);
    
            // Construct tile server URL
            const tileServer = "https://tiles-test-b.landscan.ai";
            const tileUrl = `${tileServer}/stac/${z}/${x}/${y}@2x?url=${encodeURIComponent(assetUrl)}`;
    
            console.log("B030215  Tile Image URL:", tileUrl);
    
            // Fetch and display the tile image
            const img = new Image();
            img.src = tileUrl;
            img.onload = () => console.log("B030215  Tile image loaded successfully.");
            img.onerror = () => console.log("B030215  Error loading tile image.");
            document.body.appendChild(img);
        } catch (error) {
            console.error("B030215  Error in getAssetTileImage:", error);
        }
    };
    const lon2tile = (lon: number, zoom: number) => Math.floor(((lon + 180) / 360) * Math.pow(2, zoom));
    const lat2tile = (lat: number, zoom: number) =>
        Math.floor(
            ((1 - Math.log(Math.tan((lat * Math.PI) / 180) + 1 / Math.cos((lat * Math.PI) / 180)) / Math.PI) / 2) * Math.pow(2, zoom)
        );
    
    const getTileCoordinates = (bounds: any, zoom: number) => {
        const x = lon2tile(bounds.west, zoom);
        const y = lat2tile(bounds.north, zoom); // Use north for tile Y
        return { x, y, z: zoom };
    };
        
    
    /*const getAssetTileImage = (_selectedId: string, bounds: any) => {
        console.log("B030215 Fetching clipped asset tile for", _selectedId);
    
        var xhr = new XMLHttpRequest();
        
        xhr.addEventListener("load", () => {
            console.log("B030215 Response from STAC server:", xhr);
    
            if (xhr.responseText.includes("index_not_found_exception")) {
                console.log("B030215 No asset found within bounds");
            } else {
                const response = JSON.parse(xhr.responseText);
                console.log("B030215 Full STAC Response:", response);
    
                if (response.features.length === 0) {
                    console.log("B030215 No assets returned.");
                    return;
                }
    
                // Extract asset URL
                const firstFeature = response.features[0];
                const assetUrl = firstFeature.assets.data?.href || firstFeature.assets.image?.href;
                
                if (!assetUrl) {
                    console.log("B030215 No valid asset URL found.");
                    return;
                }
    
                console.log("B030215 Asset URL:", assetUrl);
    
                // Test the asset URL directly
                const assetTestImg = new Image();
                assetTestImg.src = assetUrl;
                assetTestImg.onload = () => console.log("B030215 Asset image loads successfully.");
                assetTestImg.onerror = () => console.log("B030215 Error loading asset image.");
                document.body.appendChild(assetTestImg);
    
                // Construct tile request URL dynamically
                const tileServer = "https://tiles-test-b.landscan.ai";
                const tileUrl = `${tileServer}/stac/14/3851/6812@2x?url=${encodeURIComponent(assetUrl)}`;
    
                console.log("B030215 Tile Image URL:", tileUrl);
    
                // Fetch tile image
                const img = new Image();
                img.src = tileUrl;
                img.onload = () => console.log("B030215 Tile image loaded successfully.");
                img.onerror = () => console.log("B030215 Error loading tile image.");
                
                document.body.appendChild(img);
            }
        });
    
        // Construct STAC query URL
        if (_selectedId) {
            const dsLayerFiltered = dataSources.filter((ds: any) => ds.id === _selectedId);
            if (dsLayerFiltered.length === 0) {
                console.log("No data source found for", _selectedId);
                return;
            }
    
            const stacUrl = `${dsLayerFiltered[0].source.stac_address}?bbox=[${bounds.west},${bounds.south},${bounds.east},${bounds.north}]&collections=${_selectedId}&limit=1`;
            
            console.log("STAC Query URL:", stacUrl);
    
            // Send request to STAC server
            xhr.open("GET", stacUrl);
            xhr.send();
        }
    };*/
    
    

    const getAssetClippedToBounds = (_selectedId:string, bounds:any) => {
        console.log("030215 getAssetClippedToBounds > _selectedId", _selectedId);
        var xhr = new XMLHttpRequest();
        
        xhr.addEventListener('load', () => {
            console.log("030215 xhr", xhr);
    
            if (xhr.responseText.includes("index_not_found_exception")) {
                console.log("030215 index_not_found_exception");
                //setAssetClippedData("no asset found within bounds");
                //setClippedAsset(null);
            } else {
                console.log("030215 xhr", xhr);
                const _response = JSON.parse(xhr.responseText);
                let assetClipped:any = [];
    
                _response.features.forEach(function(f:any, index:number) {
                    console.log("030215 Feature:", f.properties);
                    assetClipped.push(f.properties);  // You can modify this line to save specific properties
                });
    
                // Set the clipped asset data or error message
                if (assetClipped.length === 0) {
                    //setAssetClippedData("no asset found within bounds");
                    //setClippedAsset(null);
                } else {
                    console.log("030215 assetClipped", assetClipped);
                    //setAssetClippedData(assetClipped);  // Assuming you want to store the asset data
                }
            }
        });
    
        // Construct the query URL to fetch the asset clipped to bounds
        if (_selectedId) {
            const dsLayerFiltered = dataSources.filter((ds:any) => ds.id === _selectedId);
            console.log("030215 dsLayerFiltered[0]", dsLayerFiltered[0]);
            
            // Construct the URL for the STAC request using bounds
            let _url = `${dsLayerFiltered[0].source.stac_address}?bbox=[${bounds.west},${bounds.south},${bounds.east},${bounds.north}]&collections=${_selectedId}&limit=200`;
    
            console.log("030215 STAC URL:", _url);
            
            // Send the request
            xhr.open('GET', _url);
            xhr.send();
        }
    }
    
    const handleFormatSliderChange = (v: any) => {
        var dateFormatted = "";
        let startDate = moment(new Date(dateSelectorParameters.min_date));
        dateFormatted = startDate.add((v + 1), 'days').format("YYYY-MM-DD");
        return dateFormatted;
    }

    /*const handleSliderChange = (evt: any) => {
        console.log("handleSliderChange evt", evt);
        console.log("dateSelected", dateSelected);
    }*/
    const handleAfterSliderChange = (evt: any, caller:string) => {
        console.log("082223 evt", evt);
        console.log("082223 caller", caller);
        console.log("082223 dateSelected", dateSelected);
        console.log("082223 year", year);
        setActiveAnimationFromParent("not engaged");
        var dateFormatted = "";
        let startDate = moment.utc(new Date(year/*dateSelectorParameters.max_date*/));
        dateFormatted = startDate.add((evt[1] ), 'days').format("YYYY-MM-DD");
        if (evt[0] !== -99){
            setDateSelected(dateFormatted);
            console.log("B021424 -- A");
            onDateChange(dateFormatted, "final");
            setDateIndexSelected(evt);
            setSelectedCounter((prevState:number) => {
                return prevState + 1;
            });
        }
    }

    const validate = (values:any) => {
        var errors: {[k: string]: any} = {}; 
        values.end_date = dateSelected;
        if (values.end_date === "") {
            errors.end_date = 'Required';
        }
        var bool1 = moment(values.end_date)
            .isBefore('2017-01-01');
        console.log(bool1);
        if (bool1) {
            errors.end_date = 'Pick date after 12-31-2016!';
        }
        return errors;
    };

    const generateTileURLsAtDates = (_rasterDataSourceToAnimate:DataSourceRasterLayer, _datesAvailable:Array<string>) => {
        const keyFramedRasterDataSourceToAnimate = _datesAvailable.map((dateString: string, index:number) => { 
            let _tempDS = {..._rasterDataSourceToAnimate};
            _tempDS["opacity"] = 0;
            _tempDS["dateString"] = dateString;
            _tempDS.id = `${_tempDS.id}_${index}`;
            _tempDS.uuid = `${_tempDS.uuid}_${index}`;
            _tempDS.tiles = getTileUrlTemplate(
                _tempDS.source,
                _tempDS.source.stac_address!, 
                _tempDS.source.collection_id!,
                'footprint_id',
                _tempDS.source.min_date,
                dateString,
                _tempDS.source.date_display_resolution!,
                "template-singledate-p1",
                null,
            )
            return _tempDS;
        })
        return keyFramedRasterDataSourceToAnimate;
    };

    const loadAnimationTiles = (_dateSelectorParameters:any) => {
        let _datesAvailable:Array<string> = [];
        let _sequence = _dateSelectorParameters.sequence;

        for (let s in _sequence){
            if ((parseInt(_sequence[s][0]) >= dateIndexSelected[0]) && (parseInt(_sequence[s][0]) <= dateIndexSelected[2])){
                _datesAvailable.push(s)
            }
        };
        //console.log("loadAnimationTiles > _datesAvailable", _datesAvailable); 
        //console.log("loadAnimationTiles > selected", selected); 
        setFilteredDatesAvailable(_datesAvailable);

        if (selected){            
            let tempArray = generateTileURLsAtDates(selected, _datesAvailable);
            let tempUASImageryArray = null;
            if (highResNormalColor){
                tempUASImageryArray = generateTileURLsAtDates(highResNormalColor, _datesAvailable);
            }
            if (setAnimationRasterDataSources){
                setAnimationRasterDataSources(tempArray);
            }
            if (setUASImageryAnimationRasterDataSources && tempUASImageryArray){
                setUASImageryAnimationRasterDataSources(tempUASImageryArray);
            }
            if(setLoadedTiles){
                setLoadedTiles(false);
            }
        }
    };

    const playAnimation = function(event:any){  
        //console.log("playAnimation", event);    
        if (setActiveAnimationFromParent){
           setActiveAnimationFromParent("playing");
        }
        if (loadAnimationTiles){
            loadAnimationTiles(dateSelectorParameters)
        }
    };

    const pauseAnimation = function(event:any){
        if (setActiveAnimationFromParent){
            setActiveAnimationFromParent("paused");
        }
    };

    const result = (
        //console.log("B082223 dateSelectorParameters", dateSelectorParameters),
        (dateSelectorParameters && Object.keys(dateSelectorParameters?.marks).length > 0) //&& visible
        ? <div 
            className="text-dark shadow-sm rounded-lg"
            //id="l2ImageryTimeline"
            style={{
                backgroundColor:'white', 
                width:'100%', 
                position: 'absolute', 
                bottom:'5px', 
                right:'0px', 
                height: 'height', 
                pointerEvents:'all'
            }}
        >
            { dateSelectorParameters
                ? <div style={{
                    display:"flex",
                    marginLeft:"10px",
                }}>
                    <div style={{display:"block", width: "100%", paddingRight: "10px"}}>
                        <div style={{marginRight:"0px", marginTop:"5px"}}>
                            <Slider2
                                key={selectedCounter}
                                style={{marginBottom:"25px"}}
                                min={0}
                                max={dateSelectorParameters.totalDays}
                                defaultValue={dateIndexSelected}
                                marks={dateSelectorParameters.marks}
                                handle={handle}
                                tipFormatter={handleFormatSliderChange}
                                //onChange={(e: any) => handleSliderChange(e)} 
                                onAfterChange={(e: any) => handleAfterSliderChange(e, "B")} 
                                step={null}
                                handleStyle={[
                                    { backgroundColor: "#ffffff00", borderRadius: '0.5px', border: '2px solid #6c757d', width:'10px', height:'20px', borderRight: 'none', marginLeft:'-4.5px', marginTop:'-8.5px', zIndex: 40 },
                                    { backgroundColor: "#6c757d", height:'20px', width:'20px', marginTop:'-8.5px', zIndex: 50 },
                                    { backgroundColor: "#ffffff00", borderRadius: '0.5px', border: '2px solid #6c757d', width:'10px', height:'20px', borderLeft: 'none', marginLeft:'4.5px', marginTop:'-8.5px', zIndex: 41 }
                                ]}
                            />
                        </div>
                    </div>
                    { !visibleDW
                        ? <div
                            className="rounded-lg shadow-sm"
                            style={{/*height: "60px",*/ width: "57px", backgroundColor: "#fff", color:"#666"}}
                        >
                            <div
                                style={{width: "60px", height: "50px", textAlign:"center", marginTop:"7px", cursor:"pointer", pointerEvents: "all"}}
                                onClick={(e:any) => {
                                    if (activeAnimation === "playing"){
                                        pauseAnimation(e);
                                    }else{
                                        playAnimation(e);
                                    }
                                }}
                            >
                            { loadedTiles 
                                ? (activeAnimation === "playing")
                                    ? <>
                                        <FontAwesomeIcon icon={faPause} />
                                        <div
                                            style={{width: "60px", height: "30px", textAlign:"center", fontSize: "12px", marginTop:"7px"}}
                                        >
                                            Pause
                                        </div>
                                    </>
                                    : <>
                                        <FontAwesomeIcon icon={faPlay} />
                                        <div
                                            style={{width: "60px", height: "30px", textAlign:"center", fontSize: "12px", marginTop:"7px"}}
                                        >
                                            Animate
                                        </div>
                                    </>
                                : <LoadingSpinnerSmall message="Loading..."></LoadingSpinnerSmall>
                            }
                            </div>
                        </div>
                    : <></>}
                </div>
            : <></>}
        </div>
        :<div 
            className="text-dark shadow-sm rounded-lg border"
            //id="l2ImageryTimeline"
            style={{backgroundColor:'#ffffff', width:'calc(100% - 20px)', position: 'absolute', bottom:'5px', right:'10px', height: '60px', paddingLeft: '5px', paddingRight: '5px'}}
        > 
            {/*console.log("060523 selected", selected)*/}
            <div style={{display:"flex"}}>
                <div style={{display:"block", width: "100%", paddingRight: "5px"}}>
                    <div style={{marginRight:"0px", marginTop:"17.5px", textAlign: "center", fontSize:"10pt"}}>
                        {selected ? `${selected.display} imagery not available` : `Imagery not available`}
                    </div>
                </div>
            </div> 
        </div> 
      );

    useEffect(() => {
        ReactDOM.render(result, document.getElementById("l2ImageryTimeline"));
    });
    
    return (
        <div className="d-flex flex-column mb-2 border p-2 rounded text-sm">
            <Form.Check 
                type="checkbox"
                label="DVS Imagery"
                checked={visible}
                onChange={() => {
                    const nextState = !visible;
                    setVisible(nextState);
                }}
            />
            <div className="d-flex mt-3">
                <Form.Control as="select"
                    size="sm"
                    onChange={(e: any) => onSourceChange(e)}
                    value={selected ? `{"id":"${selected.id}","disambiguate":"${selected.name}"}` : undefined}>
                    { dataSources.length < 1 
                        ? <option key={"none"} value={undefined}>No DVS images available</option>
                        : dataSources.sort((a:any, b:any) => b.order - a.order).map((source:any, index:number)=> (
                            (source.name !== "ESRI") && (source.name !== "ESRI_LABELS")
                                ? <option key={`${source.id}_${index}`} value={`{"id":"${source.id}","disambiguate":"${source.name}"}`}>{source.display}</option>
                                : null
                            ))
                        }
                </Form.Control>
            </div>

        { colorRampParameters[0] === 0 && colorRampParameters[1] === 255 
        ? <></>
        : <div className="mt-3">
            <div style={{width: "100%", height: 40, textAlign: "center", }}>
                <Gradient width={240} height={15} ramp={gradientParameters} inverse={false} />
                <br/>
                <div style={{height: 15, width:240, display:'inline-block'}}>
                    <div style={{float:'left'}}>{`${(colorRampParameters[0]!==undefined && colorRampParameters[0]!==null) ? dcRound(colorRampParameters[0]).toString() : ""}`}</div>
                    <div style={{float:'right'}}>{`${(colorRampParameters[1]!==undefined && colorRampParameters[1]!==null) ? dcRound(colorRampParameters[1]).toString() : ""}`}</div>
                </div>
            </div>
         </div> 
        }
        </div>
    );
}

export default L2ImagerySourceLayer;